import { TypeService, ViewService } from '@sol/components';
import { NoteType } from '../models/note-type';
import { NotesViewId } from '../models/notes-view-id';

/** Registers the Notes type and its read view, like `provideAsmIntegrationsViews` does for linked integrations. */
export function provideAnnotationNotesViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(NoteType.note);
  viewService.addView(
    NoteType.note.array,
    'read',
    NotesViewId.notes,
    () => import('../components/notes-view/notes-view.component').then(m => m.NotesViewComponent),
    true,
  );
}
